import ModalSeplag from "../../../components/ModalSeplag";
import RotuloSeplag from "../../../components/RotuloSeplag";
import { InputText } from "primereact/inputtext";
import TableSeplag from "../../../components/TableSeplag";
import { Button } from "primereact/button";
import { useState } from "react";
import { getUsersNoPaginate, getUsersPaginate } from "../../../service/Rag/Permissoes";
const FilterUser = ({ visibleFilter, setVisibleFilter, setUserSelected }) => {
  const [inputBusca, setInputBusca] = useState("");
  const [textinputBusca, setTextInputBusca] = useState("");
  const [metadata, setMetadata] = useState({
    totalElements: null,
    totalPages: null,
  });

  const [users, setUsers] = useState(null);
  const [messagemUsuarioBusca, setMessagemUsuarioBusca] = useState(null);

  const camposTabela = [{ titulo: "Nome", nome: "pessoa.nomePessoa" }];
  const paginacao = async (event) => {
    getUsers({ paginate: true, page: event.page });
  };
  const getUsers = ({ paginate, page }) => {
    if (inputBusca.length < 3) {
      return window.$toast.current.show({
        severity: "error",
        summary: "Erro na Validação",
        detail: "Para Buscar o nome, deve possuir no minimo tres caracteres",
        life: 3000,
      });
    }
    const userBody = {
      nome: inputBusca,
      todoNome: true,
    };
    if (paginate === false) {
      getUsersNoPaginate(userBody).then((res) => {
        setUsers(res.data.content);
        setMetadata({
          totalElements: res.data.totalElements,
          totalPages: res.data.totalPages,
        });

        if (res.data.content.length === 0) {
          setMessagemUsuarioBusca(true);
        } else {
          setMessagemUsuarioBusca(false);
          setTextInputBusca(inputBusca);
        }
      });
    }
    if (paginate === true) {
      getUsersPaginate(userBody, page).then((res) => {
        setUsers(res.data.content);

        if (res.data.content.length === 0) {
          setMessagemUsuarioBusca(true);
        } else {
          setMessagemUsuarioBusca(false);
          setTextInputBusca(inputBusca);
        }
      });
    }
  };
  const selectedUser = (userRow) => {
    setUserSelected(userRow);
    setVisibleFilter(false);
  };
  return (
    <ModalSeplag
      titulo="Busca de Usuário"
      tamanho="1200px"
      visible={visibleFilter}
      fechar={() => {
        setVisibleFilter(false);
      }}
      type="NONE"
    >
      <form>
        <div className="field col-12 ">
          <div className="p-fluid grid line-height-4">
            <div className="field col-12 md:col-8 ">
              <RotuloSeplag nome="Nome ( com no mínimo 3 letras )">
                <InputText
                  type="text"
                  value={inputBusca}
                  placeholder="Digite o Nome, email ou CPF (sem pontos) do usuário"
                  onChange={(e) => {
                    setInputBusca(e.target.value);
                  }}
                  onKeyPress={(event) => {
                    if (event.key === "Enter") {
                      event.preventDefault();
                      getUsers({ paginate: false });
                    }
                  }}
                />
              </RotuloSeplag>
            </div>
            <div className="field col-12 md:col-4 ">
              <RotuloSeplag>
                <Button
                  type="button"
                  icon="pi pi-search"
                  label="Buscar"
                  className="p-button-success"
                  onClick={() => {
                    getUsers({ paginate: false });
                  }}
                ></Button>
              </RotuloSeplag>
            </div>
          </div>
        </div>
      </form>
      {users !== null && (
        <TableSeplag
          camposTabela={camposTabela}
          dados={users}
          totalRecords={metadata.totalElements}
          onPage={paginacao}
          selectionMode="single"
          onSelectionChange={selectedUser}
        />
      )}
    </ModalSeplag>
  );
};
export default FilterUser;
